import gql from 'graphql-tag'
import { filter, map, mergeMap, Subject, switchMap } from 'rxjs'
import {
  FETCH_SMS_DETAILS,
  FETCH_SMS_HISTORY,
  FETCH_SMS_MEMBERS_SUBSCRIBED,
  FETCH_SMS_MEMBERS_UNSUBSCRIBED,
  FETCH_SMS_USER,
  loadSmsDetails,
  loadSmsHistory,
  loadSmsMembers,
  loadSmsUser
} from '../Actions/Sms'
import client from '../ApolloClient'
import { failFetch } from '../Actions/Other'
import { ofType } from 'redux-observable'

const smsDetailsQuery = gql`query getSmsDetails($alertId: String!) {
  getSmsDetails (alertId: $alertId) {
    title
    deliveryCounts {
      delivered
      undelivered
      failed
    }
    memberCounts {
      subscribed
      pending
      unsubscribed
    }
  }
}`

export const smsDetailsEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_SMS_DETAILS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: smsDetailsQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSmsDetails(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const smsMembersQuery = gql`query getSmsMembers($alertId: String!, $subscribed: Boolean!, $limit: Int!, $offset: Int!) {
  getSmsMembers (alertId: $alertId, subscribed: $subscribed, limit: $limit, offset: $offset) {
    members {
      _id
      name
      status
      regCode
      email
      phoneNumber
    }
    count
  }
}`

export const smsMembersSubscribedEpic = action$ =>
  action$.pipe(
    ofType(FETCH_SMS_MEMBERS_SUBSCRIBED),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: smsMembersQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSmsMembers(response.data, FETCH_SMS_MEMBERS_SUBSCRIBED)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

export const smsMembersUnsubscribedEpic = action$ =>
  action$.pipe(
    ofType(FETCH_SMS_MEMBERS_UNSUBSCRIBED),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: smsMembersQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSmsMembers(response.data, FETCH_SMS_MEMBERS_UNSUBSCRIBED)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const smsUserQuery = gql`query smsUser($accountId: String!, $memberId: String!) {
  getSmsUser(accountId: $accountId, memberId: $memberId) {
    regcode
    userId
    name
    phoneNumber
    status
    updatedOn
  }
}`

/**
 * smsUserEpic
 * @desc action Observer that sends a query and processes result if the action is a smsUser action
 * @param {Observable<action>} action$ Action Observable stream
 * @return {action}
 */
export const smsUserEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_SMS_USER),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: smsUserQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSmsUser(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const smsHistoryQuery = gql`query smsHistory($accountId: String!, $memberId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int, $sourceType: SourceType!) {
  getSmsHistory (accountId: $accountId, memberId: $memberId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, sourceType: $sourceType) {
    smsData {
      title
      status
      timestamp
    }
    count
  }
}`

export const smsHistoryEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_SMS_HISTORY),
    mergeMap(action => {
      const subject = new Subject()
      client.query({ query: smsHistoryQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSmsHistory(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
